import { CampaignElementType } from 'scenes/common/types';
import { HomeFlowType } from 'scenes/home/types';

export const campaignFlowMapping: {
  [key in CampaignElementType]: HomeFlowType[];
} = {
  [CampaignElementType.GetEstimate]: [HomeFlowType.QuoteDetails],
  [CampaignElementType.ExactQuote]: [HomeFlowType.CoverOptions],
  [CampaignElementType.PolicyDetails]: [HomeFlowType.PolicyDetails],
};
